// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"00ef1258","977":"36a0c008"}[chunkId] + ".chunk.js";
};